"use client";

import { AppProviders } from "@/providers/app-provider";

export function Providers({ children }: { children: React.ReactNode }) {
  return <AppProviders>{children}</AppProviders>;
}
